export default "__VITE_ASSET__CoTPJUfc__"